import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const createLeadFollowUp = (data, token) => {
  return axios.post(`${baseUrl}/leadFollowup`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const createLeadContact = (data, token) => {
  return axios.post(`${baseUrl}/leadContact`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const createLeadNote = (myFile, query, token) => {
  let qs = buildQuery(query);
  return axios.post(`${baseUrl}/leadNote${qs}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export const getPdfViewer = (id, token) => {
  let url = `${baseUrl}/downloadleadfile/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
